export const UMB_COLLECTION_ALIAS_CONDITION = 'Umb.Condition.CollectionAlias';

/** @deprecated No longer used internally. This will be removed in Umbraco 17. [LK] */
export const UMB_COLLECTION_BULK_ACTION_PERMISSION_CONDITION = 'Umb.Condition.CollectionBulkActionPermission';
